module.exports = __webpack_public_path__ + "img/Award.65eaf540.svg";